
<script>

import List from '@/components/ListDefault'


export default {
  name: "ListCISTasks",

  components: {
    List,
  },

  created() {


  },

  data () {
    return {
      search: '',
      formview: 'FormCISTask',
      table: 'cis_task',
    }
  },


  computed: {
    headers () {
      return [
        { text: 'Auftragsdatum', value: 'date' },
        { text: 'Kunde', value: 'company' },
        { text: 'Strasse', value: 'street' },
        { text: 'PLZ', value: 'zipcode' },
        { text: 'Stadt', value: 'city' },
        { text: 'Ausführungsfrist', value: 'execution_date'}, 
        { text: 'Bemerkungen', value: 'note' },
        { text: '', value: 'edit' },
    
      ]
    },
  },
  methods: {

  },

  
  }

</script>

<style scoped>

</style>


<template>
  <div>
    <List
      ref="listComponent"
      v-bind:headers="headers"
      v-bind:formview="formview"
      v-bind:table="table"
      v-bind:default_limit="'1000'"
      v-bind:default_sort="'date'"
      v-bind:default_sort_typ="'DESC'"
      
      v-bind:extension="''"
      v-bind:export_csv="false"
      v-bind:addbutton="false"
     

    >
    
    






    </List>
  </div>
</template>

<style scoped>


</style>